<template>
  <div>

    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Pedidos Pagos</h2>

          <b-table
            :items="orders"
            :fields="tableFields"
            striped
            hover
            responsive
            show-empty
            empty-text="Nenhum pedido encontrado"
            class="my-4"
          >
            <template #cell(value)="data">
              {{ data.value | currency }}
            </template>

            <template #cell(discount)="data">
              <span v-if="data.value > 0">
                {{ data.value | currency }}
              </span>
              <span v-else class="text-muted">-</span>
            </template>

            <template #cell(net_value)="data">
              {{ (data.item.value - data.item.discount) | currency }}
            </template>

            <template #cell(coupon_code)="data">
              <span v-if="data.value">{{ data.value }}</span>
              <span v-else class="text-muted">-</span>
            </template>

            <template #cell(created_at)="data">
              {{ data.value | date }}
            </template>

            <template #head(location)>
              <span v-b-popover.hover.top="'Localização da pessoa baseada no IP no momento da geração do pedido.'" title="Ajuda">
                Geolocalização
              </span>
            </template>

            <template #cell(location)="data">
              <span v-if="data.value">{{ data.value }}</span>
              <span v-else class="text-muted">-</span>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
export default {
  name: 'OrganizerOrdersList',
  data () {
    return {
      organizer: '',
      orders: [],
      event: {},
      baseTableFields: [
        { key: 'order_id', label: 'Pedido', class: ['align-middle', 'text-nowrap'] },
        { key: 'email', label: 'Comprador', class: ['align-middle', 'text-nowrap'] },
        { key: 'amount', label: 'Quantidade', class: ['text-center', 'align-middle'] },
        { key: 'value', label: 'Valor', class: ['text-center', 'align-middle', 'text-nowrap'] }
      ],
      discountFields: [
        { key: 'discount', label: 'Desconto', class: ['text-center', 'align-middle', 'text-nowrap'] },
        { key: 'net_value', label: 'Valor Líquido', class: ['text-center', 'align-middle', 'text-nowrap'] },
        { key: 'coupon_code', label: 'Cupom', class: ['text-center', 'align-middle'] }
      ],
      endTableFields: [
        { key: 'created_at', label: 'Data', class: ['text-center', 'align-middle', 'text-nowrap'] },
        { key: 'location', label: 'Geolocalização', class: ['align-middle', 'text-nowrap'] }
      ]
    }
  },
  computed: {
    tableFields () {
      if (this.event.coupon_discount_enabled === 1) {
        return [...this.baseTableFields, ...this.discountFields, ...this.endTableFields]
      }
      return [...this.baseTableFields, ...this.endTableFields]
    }
  },
  async mounted () {
    this.organizer = this.$route.params.organizer
    await this.getEvent()
    this.getOrders()
      .then(res => {
        if (res.body.orders.length > 0) {
          this.orders = this.$_.orderBy(res.body.orders, ['id'], ['desc'])
        }
      })
  },
  methods: {
    async getEvent () {
      const res = await this.$http.get(process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/events`)
      this.event = res.body
    },
    getOrders () {
      return this.$http.get(process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/orders`)
    }
  }
}
</script>
